import React from "react";
import Logo from "../../assets/logos/logoX.png";

const Error: React.FC = () => {
  return (
    <div className="w-screen h-screen">
      <div className="h-2/4 bg-white relative flex justify-center">
        <img
          className="absolute w-10 h-14 left-5 top-5"
          src={Logo}
          alt="logo NEXUM"
        />
        <h2 className="text-9xl font-extrabold absolute bottom-[-15px] text-dark-lavender">
          404
        </h2>
      </div>
      <div className="h-2/4 bg-dark-lavender">
        <p className="text-center pt-10 text-white text-6xl font-bold">
          Désolé, page introuvable
        </p>
      </div>
    </div>
  );
};

export default Error;
